export const dashboard = {
  title: "Διαισθητικός πίνακας ελέγχου",
  subtitle:
    "Διαχειριστείτε όλες τις ανταλλαγές σας από μια απλή και μοντέρνα διεπαφή",
  features: {
    stats: {
      title: "Λεπτομερή στατιστικά",
      description:
        "Παρακολουθήστε τα Νύχτες, τις ανταλλαγές και την εξοικονόμησή σας σε πραγματικό χρόνο",
    },
    notifications: {
      title: "Έξυπνες ειδοποιήσεις",
      description:
        "Λάβετε ειδοποιήσεις για νέα αιτήματα και σημαντικά μηνύματα",
    },
    management: {
      title: "Απλοποιημένη διαχείριση",
      description:
        "Διαχειριστείτε τις διαθεσιμότητες, τις κρατήσεις και τις ανταλλαγές σας με μερικά κλικ",
    },
  },
  cta: "Ανακαλύψτε τον πίνακα ελέγχου",
  exchangeConfirmed: "Ανταλλαγή επιβεβαιώθηκε",
  newRequests: "νέα αιτήματα",
  toReview: "Προς εξέταση",
};
